import { ArrowDown } from 'lucide-react';
import bgImage from '../assets/images/hero.jpg';

export function Hero() {
  const scrollToServices = () => {
    const element = document.getElementById('usluge');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={bgImage}
          alt="Modern furniture"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/50 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <div className="mb-6 inline-block px-6 py-2 bg-[#AB7C1B] backdrop-blur-sm rounded-full text-white/90 text-sm">
          Vaša vizija, naša kreacija
        </div>
        
        <h1 className="text-5xl md:text-7xl mb-6 text-white">
          Namještaj po mjeri
        </h1>
        
        <p className="text-lg md:text-xl text-white/80 mb-12 max-w-3xl mx-auto">
          Ukoliko vam treba novi dio namještaja ili jednostavno želite promijeniti ugođaj u vašem domu, a ne znate kako, kontaktirajte nas.
        </p>

        <button
          onClick={scrollToServices}
          className="bg-white text-gray-900 px-8 py-4 rounded-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl inline-flex items-center gap-2"
        >
          Saznajte više
          <ArrowDown className="w-5 h-5" />
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ArrowDown className="w-6 h-6 text-white/60" />
      </div>
    </section>
  );
}
